import * as Sentry from "@sentry/browser";
import { getUserDetail } from "./landing/helper";
import { LOG_TYPE } from "./api/constant";

class LogService {
  init() {
    Sentry.init({
      dsn: "https://c33a81b67297a0c386e2b44b6854686c@clog.affilio.ir/8",
      integrations: [
        new Sentry.BrowserTracing({
          // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
          tracePropagationTargets: [
            "localhost",
            /^https:\/\/yourserver\.io\/api/,
          ],
        }),
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
    });

    Sentry.onLoad(() => {
      const ud = getUserDetail();
      Sentry.setTags({
        host: ud?.host,
      });
      Sentry.setExtras({
        pageUrl: ud?.pageUrl,
      });
      Sentry.captureMessage(LOG_TYPE.WIDGET_INIT);
    });
  }

  send(data) {
    Sentry.setExtras(data);
    Sentry.captureMessage(data.eventType);
  }
}

const logService = new LogService();
export default logService;
